import { usePreviewPanelsContext } from '../preview-panel-context';
import type { OpenParams } from '../types';

const noop = (props?: any) => {};

/**
 * @private
 * @deprecated `@atlassian/preview-panels-api` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const usePreviewPanelsActions = (): {
	close: (onClose?: () => void) => void;
	open: (params: OpenParams) => void;
	setPanelWidth: (width: number) => void;
} => {
	const context = usePreviewPanelsContext();
	if (!context) {
		return {
			open: noop,
			close: noop,
			setPanelWidth: noop,
		};
	}

	return {
		open: context.open,
		close: context.close,
		setPanelWidth: context.setPanelWidth,
	};
};
